import { type VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';

import styles from './Buttons.module.less';

type Props = {
  /**
   * Handler when reject button is clicked.
   */
  onRejectClick: () => void;
  /**
   * Handler when "Download" button is clicked.
   */
  onDownloadClick: () => void;
};

/**
 * Action buttons for the SnippetsDrawer
 */
const SnippetsDrawerButtons: VoidFunctionComponent<Props> = ({
  onRejectClick,
  onDownloadClick,
}) => (
  <div className={styles.buttons}>
    <Button
      type="secondary"
      size="medium"
      onClick={onRejectClick}
    >
      Reject
    </Button>
    <Button
      type="secondary"
      size="medium"
      onClick={onDownloadClick}
    >
      Download Match Data
    </Button>
  </div>
);

export default SnippetsDrawerButtons;
